import http from '../../../libs/http';
import * as types from './user-mutation-types';

/**
 * 获取用户信息
 */
export const peerAccountQuery = ({ commit }) => http.post('/peer_account_query').then((data) => {
  commit(types.SET_USER_DATA, data);
  return data;
});

/**
 * 获取同业信息
 */
export const visaPeerQuery = ({ commit }) => http.post('/visa_peer_query').then((data) => {
  commit(types.SET_PEER_DATA, data);
  return data;
});

/**
 * 获取对公汇款信息
 */
export const publicAuditQuery = ({ commit }) => http.post('/visa_peer_corporate_remittance_brief_query', { page: 1 }).then((data) => {
  commit(types.SET_AUDIT_DATA, data);
  return data;
});

let ipAddress = null;

export const getIPLocation = ({ commit }) => new Promise((resolve, reject) => {
  if (ipAddress && ipAddress.province_code) {
    return resolve(ipAddress);
  }
  http.post('/sys/ip_location_get', {}).then((data) => {
    ipAddress = data;
    resolve(data);
    commit(types.SET_IP_ADDRESS, data);
  }).catch((e) => {
    if (e) console.log(e);
    reject();
  });
});

// 在修改专属商务的时候 很多地方已经在使用专属客服了 这时候数据汇总容易测不全 所以只是提取公共部分进行优化
const promisesCache = {};

/**
 * 通用数据服务
 * @param {String} endpoint API 接口路径
 * @param {String} cacheKey 缓存的唯一键
 * @returns {Promise} 数据请求的 Promise
 */
export const fetchDataFromApi = (endpoint, cacheKey) => {
  if (promisesCache[cacheKey]) {
    return promisesCache[cacheKey];
  }

  promisesCache[cacheKey] = http.post(endpoint)
    .then((data) => {
      promisesCache[cacheKey] = null; // 清空缓存
      return data;
    })
    .catch((err) => {
      promisesCache[cacheKey] = null; // 清空缓存
      throw err;
    });

  return promisesCache[cacheKey];
};


export const getPeerCSData = ({ state, commit }, refresh = false) => {
  if (state.peerCSData && !refresh) {
    return Promise.resolve(state.peerCSData);
  }
  return fetchDataFromApi('/peer_cs_query', 'peerCSData')
    .then((data) => {
      commit(types.SET_CS_DATA, data.peer_cs);
      return data.peer_cs;
    });
};

export const getPeerBdData = ({ state, commit }, refresh = false) => {
  if (state.peerBdData && !refresh) {
    return Promise.resolve(state.peerBdData);
  }
  return fetchDataFromApi('/peer_cs_query', 'peerBdData')
    .then((data) => {
      commit(types.SET_BD_DATA, data.peer_bd);
      return data.peer_bd;
    });
};


// let getPeerCSDataPromise = null;
// export const getPeerCSData = ({ state, commit }, refresh = false) => {
//   if (state.peerCSData && !refresh) {
//     return Promise.resolve(state.peerCSData);
//   }
//   if (getPeerCSDataPromise) {
//     return Promise.resolve(getPeerCSDataPromise);
//   }
//   getPeerCSDataPromise = http.post('/peer_cs_query').then((data) => {
//     commit(types.SET_CS_DATA, data.peer_cs);
//     getPeerCSDataPromise = null;
//     return data.peer_cs;
//   }).catch((err) => {
//     getPeerCSDataPromise = null;
//     return Promise.reject(err);
//   });
//   return getPeerCSDataPromise;
// };

// let getPeerBdDataPromise = null;
// export const getPeerBdData = ({ state, commit }, refresh = false) => {
//   if (state.peerBdData && !refresh) {
//     return Promise.resolve(state.peerBdData);
//   }
//   if (getPeerBdDataPromise) {
//     return Promise.resolve(getPeerBdDataPromise);
//   }
//   getPeerBdDataPromise = http.post('/peer_cs_query').then((data) => {
//     commit(types.SET_BD_DATA, data.peer_bd);
//     getPeerBdDataPromise = null;
//     return data.peer_bd;
//   }).catch((err) => {
//     getPeerBdDataPromise = null;
//     return Promise.reject(err);
//   });
//   return getPeerBdDataPromise;
// };



// WEBPACK FOOTER //
// ./src/store/modules/user/user-actions.js